import TariffPeriod from "../../../utils/services/project/metering/tariffPeriodService";
import crudTemplate from "../../../templates/crudTemplate";

let crud = crudTemplate(TariffPeriod);

const state = {
  ...crud.state
};

const getters = {
  ...crud.getters,
  getList(state, getters, rootState, rootGetters) {
    let list = crud.getters.getList(state);
    let project = rootGetters["projectStore/getCurrentItem"];
    let tariff = rootGetters["projectMeteringStore/tariffStore/getItem"];
    let currency_per_unit_symbol = `${project.currency}/${tariff.unit_symbol}`;
    return list.map(i => ({
      ...i,
      currency_per_unit_symbol
    }));
  }
};

const actions = {
  ...crud.actions
};

const mutations = {
  ...crud.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
